var image_viewer_rtlignore_default = {
  "fontElementMap": "S-ELG",
  "imageContainer": "Eswhf",
  "expandContainer": "VtuvT",
  "expandIcon": "leGkP",
  "pointer": "z-4Pg",
  "imageWrapper": "_2ynrX",
  "imageRatio": "bqdPo",
  "image": "hhmfZ",
  "imageOverlay": "_3xNdA",
  "imageCaption": "ki9MR",
  "imagePreload": "_-2Uyt",
  "imageHighres": "lW5pE",
  "onlyHighRes": "KGSFs",
  "image_loading": "wUsxn"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore.scss.js.map
